export default [
  {
    path: '/homeIndex',
    meta: {
      title: '启动页'
    },
    component: () => import('../../view/homeIndex/homeIndex')
  }
]



// WEBPACK FOOTER //
// ./src/router/module/homeIndex.js